import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { SlotController } from '../common/controllers/SlotController.js'
import componentStyle from '../common/styles/Component.css'
import style from './Header.css'

/**
 * The header is a block of designated space for labelling the currently
 * viewed context as well as providing primary actions.
 *
 * @status ready
 * @category layout
 * @slot - The header content.
 * @slot end - Optional slot for buttons, toggles, etc.
 *
 * @cssprop [--n-header-background-color=var(--n-color-surface)] - Background color of the header.
 */
@customElement('nord-header')
export default class Header extends LitElement {
  static styles = [componentStyle, style]

  private endSlot = new SlotController(this, 'end')

  /**
   * Controls the size of the header component.
   */
  @property({ reflect: true }) size: 'm' | 's' | 'xs' = 'm'

  render() {
    return html`
      <header class="n-header">
        <slot></slot>
        <div class="n-header-end" ?hidden=${this.endSlot.isEmpty}>
          <slot name="end"></slot>
        </div>
      </header>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-header': Header
  }
}
